var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentShareIconMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3927 6.03168L17.6457 4.51461C16.3871 3.42153 15.8937 2.83352 15.2121 3.04139C14.3622 3.30059 14.642 4.93609 14.642 5.48824C13.3206 5.48824 11.9468 5.38661 10.6443 5.59836C6.34453 6.29742 5 9.3566 5 12.6525C6.21697 11.9065 7.43274 11.0746 8.8954 10.7289C10.7212 10.2973 12.7603 10.5032 14.642 10.5032C14.642 11.0554 14.3622 12.6909 15.2121 12.9501C15.9844 13.1856 16.3871 12.5699 17.6457 11.4769L19.3927 9.9598C20.4642 9.0293 21 8.564 21 7.99574C21 7.4275 20.4642 6.96223 19.3927 6.03168Z",
    stroke: "#612680",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5676 1C5.70735 1.00694 3.68594 1.10152 2.39411 2.39073C1 3.78202 1 6.02125 1 10.4997C1 14.9782 1 17.2174 2.3941 18.6087C3.78821 20 6.03198 20 10.5195 20C15.0071 20 17.2509 20 18.645 18.6087C19.6156 17.64 19.9104 16.2603 20 14",
    stroke: "#612680",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentShareIconMobile);
export default __webpack_public_path__ + "static/media/StudentShareIconMobile.ce10f1d89a0c24cf79f4f71f1a3f795e.svg";
export { ForwardRef as ReactComponent };